(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bh-product]:not([data-bh-ready])').forEach((root) => {
      root.dataset.bhReady = 'true';

      const form = root.querySelector('[data-bh-form]');
      const variantInput = root.querySelector('[data-bh-variant-input]');
      const addButton = root.querySelector('[data-bh-add]');
      const buttonText = root.querySelector('[data-bh-button-text]');
      const status = root.querySelector('[data-bh-status]');
      const stock = root.querySelector('[data-bh-stock]');
      const stockText = root.querySelector('[data-bh-stock-text]');
      let submitting = false;

      root.querySelectorAll('[data-bh-gallery]').forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const main = root.querySelector('[data-bh-gallery-main]');
          if (!main) return;
          main.src = thumbnail.dataset.bhGallery;
          main.alt = thumbnail.dataset.bhGalleryAlt;
          root.querySelectorAll('[data-bh-gallery]').forEach((item) => {
            item.setAttribute('aria-pressed', String(item === thumbnail));
          });
        });
      });

      root.querySelectorAll('[data-bh-bundle]').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked || !variantInput) return;

          variantInput.value = radio.value;
          const available = radio.dataset.available === 'true';
          if (addButton) addButton.disabled = submitting || !available;
          if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Out of stock';
          if (stock) {
            stock.classList.toggle('is-sold-out', !available);
          }
          if (stockText) stockText.textContent = available ? 'In stock' : 'Out of stock';
        });
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!variantInput?.value || addButton?.disabled || submitting) return;

        submitting = true;
        root.querySelectorAll('[data-bh-bundle]').forEach((radio) => { radio.disabled = true; });
        addButton.disabled = true;
        buttonText.textContent = 'Adding…';
        status.textContent = '';

        try {
          const rootPath = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] }),
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || 'This bundle could not be added.');

          buttonText.textContent = 'Added to cart';
          status.textContent = 'Your bundle is in the cart. Redirecting to secure checkout…';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: payload }));
          window.setTimeout(() => {
            window.location.href = `${rootPath}checkout`;
          }, 500);
        } catch (error) {
          submitting = false;
          root.querySelectorAll('[data-bh-bundle]').forEach((radio) => {
            radio.disabled = radio.dataset.available !== 'true';
          });
          status.textContent = error instanceof Error ? error.message : 'Please try again.';
          const available = root.querySelector('[data-bh-bundle]:checked')?.dataset.available === 'true';
          buttonText.textContent = available ? 'Add to cart' : 'Out of stock';
          addButton.disabled = !available;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
